<template>
<button class="button is-primary is-fullwidth"
  :class="{ 'is-inverted': isInverted }"
  @click.prevent="$emit('click')">
  <span class="icon" v-if="!noTooltip && start" v-tooltip="tooltip" @mouseover="tooltipMouseover" @mouseout="tooltipMouseout">
    <img v-if="isInverted" src="../../assets/question-mark-green.svg" />
    <img v-else src="../../assets/question-mark.svg" />
  </span>
  <span class="icon"></span>
  <span><slot></slot></span>
  <span class="icon" v-if="!noTooltip && !start" v-tooltip="tooltip" @mouseover="tooltipMouseover" @mouseout="tooltipMouseout">
    <img v-if="isInverted" src="../../assets/question-mark-green.svg" />
    <img v-else src="../../assets/question-mark.svg" />
  </span>
  <span class="icon" v-else>
  </span>
</button>
</template>

<script>
export default {
  props: {
    tooltip: {
      type: String,
      required: true
    },
    isInverted: {
      type: Boolean,
      default: false
    },
    noTooltip: {
      type: Boolean,
      default: false
    },
    start: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    tooltipMouseover: function () {
      this.$emit('tooltipMouseover')
    },
    tooltipMouseout: function () {
      this.$emit('tooltipMouseout')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';

.button {
  display: flex;
  justify-content: space-between;
  padding: 0 1rem;
}

.button.is-primary.is-inverted:hover {
  background-color: rgba(62,207,142,.025)
}

.button.is-primary.is-inverted {
  border-color: $brand-primary;
}
</style>



// WEBPACK FOOTER //
// src/components/general/tooltip-button.vue